import { render, staticRenderFns } from "./ModelDialog.vue?vue&type=template&id=472a1182"
import script from "./ModelDialog.vue?vue&type=script&lang=ts"
export * from "./ModelDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports